import React, { useState } from 'react';
import GameplayScreen from './screens/gameplay/index.jsx';
import HomeScreen from './screens/home/index.jsx';
window.rs = true;
window.backgroundSFX = new Audio('assets/sounds/greensleeves.mp3');
window.backgroundSFX.loop = true;
window.backgroundSFX.volume = 0.25;
window.backgroundSFX.playingEnabled = false;

window.soundSFX = new Audio('');
window.soundSFX.playingEnabled = true;

window.ttsDialogue = new Audio('');
window.ttsDialogue.playingEnabled = false;
window.ttsDialogue.volume = 1;

function App() {
  const [currentScreen, setCurrentScreen] = useState('HomeScreen');

  return (
    <>
      { currentScreen === 'HomeScreen' && <HomeScreen setCurrentScreen={setCurrentScreen} />}
      { currentScreen === 'GameplayScreen' && <GameplayScreen exitGame={setCurrentScreen} />}
    </>
  );
}

export default App;